/* Yumi & Cie — date de livraison estimée, seconde implémentation.

   La date est déjà calculée côté serveur par « yc-eta-compute.liquid » et
   se trouve dans le HTML. Ce fichier ne sert qu'à une chose : la
   RECALCULER dans le navigateur et la corriger si la page a été servie
   depuis un cache plus vieux que la journée. Une date fausse est pire
   qu'une date absente.

   Le calcul est volontairement écrit deux fois, une fois en Liquid et une
   fois ici. Ce n'est pas une redondance de confort : le banc d'essai fait
   tourner les deux sur les mêmes cas limites et exige le même résultat.
   Deux écritures indépendantes qui tombent d'accord, c'est une preuve.

   Règle : 2 jours ouvrés fournisseur -> entrepôt, puis 3 jours ouvrés
   entrepôt -> client. Commande après 14 h, week-end ou férié : la prise en
   charge glisse au premier jour ouvré suivant.

   Toute l'arithmétique passe par le jour julien (un entier). Aucune
   addition de millisecondes : pas d'heure d'été, pas de fuseau qui dérape.
*/
(function () {
  'use strict';

  var HEURE_LIMITE = 14; // au-delà, la commande part le lendemain ouvré
  var JOURS_OUVRES = 5; // 2 (appro) + 3 (livraison)

  var CUM = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  var FIXES = [[1, 1], [5, 1], [5, 8], [7, 14], [8, 15], [11, 1], [11, 11], [12, 25]];
  /* Jours ABREGES depuis le 24/08/2026 (demande client) : « lun. 31 aout ».
     Cette liste DOIT rester le miroir de `yc.date.weekdays` dans les locales
     — le serveur ecrit la date, ce script la recalcule, et si les deux ne
     disent pas la meme chose le texte change sous les yeux du visiteur. */
  /* Plus de jour de la semaine dans la date affichée (client, 07/09/2026). */
  /* Mois abreges pour la pastille « Livraison offerte 16 nov. » (client, 07/09/2026). */
  var MOIS_COURT = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
              'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function div(a, b) {
    return Math.floor(a / b);
  }

  function bissextile(y) {
    return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0 ? 1 : 0;
  }

  /* Jour julien du 1er janvier : formule grégorienne réduite à m=1, d=1. */
  function premierJanvier(y) {
    var yy = y + 4799;
    return yy * 365 + div(yy, 4) - div(yy, 100) + div(yy, 400) - 31738;
  }

  function jourJulien(y, m, d) {
    var j = premierJanvier(y) + CUM[m - 1] + d - 1;
    if (m > 2) j += bissextile(y);
    return j;
  }

  /* Date civile depuis un jour julien. */
  function versDate(j) {
    var a = j + 32044;
    var b = div(4 * a + 3, 146097);
    var c = a - div(146097 * b, 4);
    var d = div(4 * c + 3, 1461);
    var e = c - div(1461 * d, 4);
    var m = div(5 * e + 2, 153);
    return {
      jour: e - div(153 * m + 2, 5) + 1,
      mois: m + 3 - 12 * div(m, 10),
      annee: 100 * b + d - 4800 + div(m, 10)
    };
  }

  /* Pâques — algorithme grégorien anonyme (Meeus/Jones/Butcher). */
  function paques(y) {
    var a = y % 19;
    var b = div(y, 100);
    var c = y % 100;
    var d = div(b, 4);
    var e = b % 4;
    var f = div(b + 8, 25);
    var g = div(b - f + 1, 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = div(c, 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = div(a + 11 * h + 22 * l, 451);
    var n = h + l - 7 * m + 114;
    return { mois: div(n, 31), jour: (n % 31) + 1 };
  }

  /* Les 11 fériés NATIONAUX, pour l'année demandée et la suivante (une
     livraison lancée fin décembre atterrit en janvier). Le Vendredi saint
     et le 26 décembre ne sont fériés qu'en Alsace-Moselle : non retenus. */
  function feries(y) {
    var s = {};
    for (var k = 0; k < 2; k++) {
      var yr = y + k;
      for (var i = 0; i < FIXES.length; i++) {
        s[jourJulien(yr, FIXES[i][0], FIXES[i][1])] = true;
      }
      var p = paques(yr);
      var pj = jourJulien(yr, p.mois, p.jour);
      s[pj + 1] = true; // lundi de Pâques
      s[pj + 39] = true; // Ascension
      s[pj + 50] = true; // lundi de Pentecôte
    }
    return s;
  }

  /* Samedi est ouvre : les transporteurs et l'entrepot travaillent le
     samedi. Seuls le dimanche (j % 7 == 6) et les feries sont chomes. */
  function ouvre(j, hol) {
    return j % 7 < 6 && !hol[j];
  }

  function calcule(y, m, d, h, jours) {
    var hol = feries(y);
    var cur = jourJulien(y, m, d);

    if (h >= HEURE_LIMITE) cur += 1;
    for (var garde = 0; garde < 20 && !ouvre(cur, hol); garde++) cur += 1;

    var faits = 0;
    var vise = jours || JOURS_OUVRES; // 3 pour un article de notre stock (72 h)
    for (var tour = 0; tour < 60 && faits < vise; tour++) {
      cur += 1;
      if (ouvre(cur, hol)) faits += 1;
    }

    var g = versDate(cur);
    return {
      jdn: cur,
      texte: (g.jour === 1 ? '1er' : g.jour) + ' ' + MOIS[g.mois - 1],
      court: (g.jour === 1 ? '1er' : g.jour) + ' ' + MOIS_COURT[g.mois - 1]
    };
  }

  /* L'heure de PARIS, quelle que soit l'heure du visiteur. */
  function maintenantParis() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    for (var i = 0; i < parts.length; i++) o[parts[i].type] = parts[i].value;
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24 };
  }

  function applique() {
    var n = maintenantParis();
    var r0 = calcule(n.y, n.m, n.d, n.h);
    var els = document.querySelectorAll('[data-yc-eta]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var jours = parseInt(el.getAttribute('data-yc-eta-jours'), 10);
      var r = jours ? calcule(n.y, n.m, n.d, n.h, jours) : r0;
      if (String(el.getAttribute('data-yc-eta-jdn')) === String(r.jdn)) continue;
      var fort = el.querySelector('strong');
      var court = el.classList.contains('yc-eta--offerte') || el.hasAttribute('data-yc-trajet');
      if (fort) fort.textContent = court ? r.court : r.texte;
      // Les dates du trajet du colis suivent la pastille : une seule date.
      var dates = el.querySelectorAll('[data-yc-eta-court]');
      for (var k = 0; k < dates.length; k++) dates[k].textContent = r.court;
      el.setAttribute('data-yc-eta-jdn', String(r.jdn));
    }
    return r0;
  }

  /* LE TRAJET DU COLIS (fiche produit, maquette 8B2 validée le 09/10/2026).
     La pastille de livraison déplie un panneau superposé (yc-delivery-eta).
     - Souris : survol de la pastille (120 ms d'intention, pas d'ouverture au
       simple passage) ; le panneau reste tant que la souris est à moins de
       40 px de la pastille ou du panneau ; il se replie 250 ms après qu'elle
       s'en est éloignée, ou dès que la page défile de plus de 24 px.
     - Doigt : un toucher ouvre, un autre ferme ; toucher ailleurs ou faire
       défiler ferme.
     - Clavier : le focus ouvre, Échap ferme, aria-expanded suit.
     Le panneau prend la largeur de la colonne, ne sort jamais de l'écran, et
     s'ouvre au-dessus de la pastille quand la place manque en dessous. */
  var TRAJET = { intention: 120, grace: 250, marge: 40, defilement: 24, repli: 280 };
  var mouvementReduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function dansRect(r, x, y, m) {
    return x >= r.left - m && x <= r.right + m && y >= r.top - m && y <= r.bottom + m;
  }

  function trajet(racine) {
    if (racine.ycTrajet) return;
    var bouton = racine.querySelector('[data-yc-trajet-bouton]');
    var panneau = racine.querySelector('[data-yc-trajet-panneau]');
    if (!bouton || !panneau) return;
    racine.ycTrajet = true;
    var contenu = panneau.querySelector('.yc-trajet__contenu') || panneau;
    var ouvert = false, tIntention = 0, tGrace = 0, tRepli = 0;
    var px = -1, py = -1, hautArme = 0, hautOuvert = 0, dernierType = '', par = '';

    function stop(t) { if (t) clearTimeout(t); return 0; }

    /* Largeur de la colonne (la ligne stock + livraison), dans l'écran ;
       dessous si ça tient, sinon dessus s'il y a plus de place. */
    function placer() {
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var vh = window.innerHeight;
      var hote = (racine.closest && racine.closest('.yc-availability')) || racine.parentElement || racine;
      var rh = hote.getBoundingClientRect();
      var rr = racine.getBoundingClientRect();
      var rb = bouton.getBoundingClientRect();
      var l = Math.min(440, vw - 16);
      if (rh.width >= 280) l = Math.min(l, rh.width);
      var gauche = Math.max(8, Math.min(rh.left, vw - 8 - l));
      panneau.style.width = l + 'px';
      panneau.style.left = (gauche - rr.left) + 'px';
      var pointe = rb.left + rb.width / 2 - gauche;
      panneau.style.setProperty('--yc-fleche', Math.max(22, Math.min(l - 22, pointe)) + 'px');
      // La place utile : sous l'en-tête collant, au-dessus de la barre
      // d'achat fixe quand elle est montée.
      var plafond = 8, plancher = vh - 8;
      var bords = document.querySelectorAll('.shopify-section-group-header-group, .yc-buybar');
      for (var i = 0; i < bords.length; i++) {
        var pos = window.getComputedStyle(bords[i]).position;
        if (pos !== 'sticky' && pos !== 'fixed') continue;
        var rt = bords[i].getBoundingClientRect();
        if (rt.height <= 0 || rt.bottom <= 0 || rt.top >= vh) continue;
        if (rt.top < vh / 3) plafond = Math.max(plafond, rt.bottom + 8);
        else plancher = Math.min(plancher, rt.top - 8);
      }
      var h = contenu.offsetHeight + 12;
      var dessous = plancher - rr.bottom - 10;
      var dessus = rr.top - 10 - plafond;
      racine.setAttribute('data-sens', h > dessous && dessus > dessous ? 'haut' : 'bas');
    }

    function ouvrir(qui) {
      tIntention = stop(tIntention);
      tGrace = stop(tGrace);
      tRepli = stop(tRepli);
      if (ouvert) return;
      ouvert = true;
      par = qui || '';
      panneau.classList.add('est-monte');
      placer();
      void panneau.offsetWidth; // le navigateur pose l'état fermé avant d'animer
      panneau.classList.add('est-ouvert');
      racine.classList.add('est-ouvert');
      bouton.setAttribute('aria-expanded', 'true');
      hautOuvert = bouton.getBoundingClientRect().top;
      ecouter(true);
    }

    function fermer() {
      tIntention = stop(tIntention);
      tGrace = stop(tGrace);
      if (!ouvert) return;
      ouvert = false;
      panneau.classList.remove('est-ouvert');
      racine.classList.remove('est-ouvert');
      bouton.setAttribute('aria-expanded', 'false');
      ecouter(false);
      tRepli = stop(tRepli);
      tRepli = setTimeout(function () {
        tRepli = 0;
        if (!ouvert) panneau.classList.remove('est-monte');
      }, mouvementReduit.matches ? 0 : TRAJET.repli);
    }

    function dedans(x, y) {
      if (dansRect(bouton.getBoundingClientRect(), x, y, TRAJET.marge)) return true;
      return ouvert && dansRect(panneau.getBoundingClientRect(), x, y, TRAJET.marge);
    }

    // Intention de survol : seulement un vrai mouvement de souris sur la
    // pastille (pas la page qui défile sous une souris immobile).
    function armer() {
      if (ouvert || tIntention) return;
      hautArme = bouton.getBoundingClientRect().top;
      tIntention = setTimeout(function () {
        tIntention = 0;
        var r = bouton.getBoundingClientRect();
        if (Math.abs(r.top - hautArme) > 2) return;
        if (dansRect(r, px, py, 0)) ouvrir('souris');
      }, TRAJET.intention);
    }

    function suivre(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      px = e.clientX;
      py = e.clientY;
      if (!ouvert) return;
      if (dedans(px, py)) tGrace = stop(tGrace);
      else if (!tGrace) tGrace = setTimeout(fermer, TRAJET.grace);
    }

    function defiler() {
      if (!ouvert) return;
      if (Math.abs(bouton.getBoundingClientRect().top - hautOuvert) > TRAJET.defilement) fermer();
    }

    function ailleurs(e) {
      if (!racine.contains(e.target)) fermer();
    }

    function touche(e) {
      if (e.key === 'Escape' || e.key === 'Esc') fermer();
    }

    function sortie(e) {
      // La souris quitte la fenêtre : même délai de grâce.
      if (!e.relatedTarget && ouvert && !tGrace) tGrace = setTimeout(fermer, TRAJET.grace);
    }

    function ecouter(oui) {
      var f = oui ? 'addEventListener' : 'removeEventListener';
      document[f]('pointermove', suivre, { passive: true });
      document[f]('scroll', defiler, { capture: true, passive: true });
      document[f]('pointerdown', ailleurs, true);
      document[f]('keydown', touche);
      document[f]('mouseout', sortie);
      window[f]('resize', fermer);
    }

    bouton.addEventListener('pointerdown', function (e) { dernierType = e.pointerType; });
    bouton.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      px = e.clientX;
      py = e.clientY;
      if (ouvert) tGrace = stop(tGrace);
      else if (e.movementX || e.movementY) armer();
    });
    bouton.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' && !ouvert) tIntention = stop(tIntention);
    });
    bouton.addEventListener('click', function (e) {
      if (e.detail === 0) { // clavier (Entrée, Espace)
        if (ouvert) fermer(); else ouvrir('clavier');
        return;
      }
      var type = e.pointerType || dernierType || 'mouse';
      // À la souris, c'est le survol qui commande : un clic n'ouvre que ce
      // qui est fermé (après un défilement, par exemple), il ne referme pas.
      if (type === 'mouse') { ouvrir('souris'); return; }
      if (ouvert) fermer(); else ouvrir('doigt');
    });
    bouton.addEventListener('focus', function () {
      var clavier = false;
      try { clavier = bouton.matches(':focus-visible'); } catch (x) { clavier = false; }
      if (clavier) ouvrir('clavier');
    });
    racine.addEventListener('focusout', function (e) {
      // Le focus part ailleurs (Tab) : on referme ce que le clavier a ouvert.
      // Ce que la souris a ouvert suit la souris.
      if (par === 'clavier' && (!e.relatedTarget || !racine.contains(e.relatedTarget))) fermer();
    });
  }

  function trajets() {
    var els = document.querySelectorAll('[data-yc-trajet]');
    for (var i = 0; i < els.length; i++) trajet(els[i]);
  }

  /* Ouvert au banc d'essai : il appelle « calcule » sur des dates choisies
     et compare au rendu Liquid. */
  window.ycDeliveryEta = {
    calcule: calcule,
    jourJulien: jourJulien,
    paques: paques,
    maintenantParis: maintenantParis,
    applique: applique
  };

  function lancer() {
    try {
      trajets();
    } catch (e) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
    try {
      applique();
    } catch (e) {
      /* La page ne doit pas casser pour une ligne de texte : la valeur
         posée par le serveur reste affichée. L'erreur est tout de même
         relancée hors pile, pour rester visible en console et pour tout
         banc qui écoute « error ». */
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
  document.addEventListener('shopify:section:load', lancer);

  // La propriété privée suit la ligne jusqu'au paiement, puis dans la commande.
  // Réévaluer la variante et la quantité avant que FormData ne soit construit.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.querySelector) return;
    var id = form.querySelector('[name="id"]');
    var quantity = form.querySelector('[name="quantity"]');
    if (!id) return;
    form.querySelectorAll('[data-yc-restock-property]').forEach(function (input) {
      input.disabled = input.dataset.variant !== id.value || Number(quantity ? quantity.value : 1) <= Number(input.dataset.stock);
    });
  }, true);

  // Les paniers déjà remplis et les quantités modifiées reçoivent la promesse
  // actuelle avant le paiement. Les propriétés ajoutées par d'autres outils restent.
  var checkoutBusy = false;
  var checkoutReady = new WeakSet();
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (form.id !== 'cart-form' || checkoutReady.has(form)) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    var lines = Array.from(document.querySelectorAll('[data-yc-restock-line]'));
    if (!lines.some(function (line) { return line.dataset.value || line.dataset.current; })) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    submitter.setAttribute('aria-busy', 'true');
    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Lecture du panier refusée');
      var cart = await response.json();
      var wanted = new Map(lines.map(function (line) { return [line.dataset.key, line.dataset]; }));
      var name = '_Livraison en réservation';
      for (var item of cart.items) {
        var line = wanted.get(item.key);
        if (!line || Number(line.quantity) !== item.quantity) throw new Error('Le panier a changé. Actualisez la page avant de continuer.');
        var properties = Object.assign({}, item.properties || {});
        if ((properties[name] || '') === line.value && !properties['Livraison en réservation']) continue;
        if (properties['Livraison en réservation']) properties['Livraison en réservation'] = '';
        if (line.value) properties[name] = line.value;
        else properties[name] = '';
        response = await fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
        });
        if (!response.ok) throw new Error('Actualisation du délai refusée. Réessayez.');
        var updatedCart = await response.json();
        if (updatedCart.items.length !== cart.items.length) throw new Error('Des lignes du panier ont été regroupées. Actualisez la page avant de continuer.');
      }
      checkoutReady.add(form);
      form.requestSubmit(submitter);
    } catch (error) {
      var notice = document.getElementById('yc-restock-error');
      if (!notice) {
        notice = document.createElement('p');
        notice.id = 'yc-restock-error';
        notice.setAttribute('role', 'alert');
        submitter.insertAdjacentElement('beforebegin', notice);
      }
      notice.textContent = error.message;
    } finally {
      checkoutBusy = false;
      submitter.removeAttribute('aria-busy');
    }
  }, true);
})();
